import React, { useState } from "react";
import Stepper from "@mui/material/Stepper";
import Step from "@mui/material/Step";
import StepLabel from "@mui/material/StepLabel";
import StepConnector, {
  stepConnectorClasses,
} from "@mui/material/StepConnector";
import { styled } from "@mui/material/styles";
import SchoolIcon from "@mui/icons-material/School";
import { skill } from "../../constants/about";
import picme4 from "../../assets/images/trax2.png";
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay, Pagination } from "swiper/modules";
import "swiper/css/effect-coverflow";
import "swiper/css";
import { EffectCoverflow } from "swiper/modules";
import "swiper/css/pagination";
import "swiper/css/navigation";
import { experiences } from "../../constants/experience";
import { Link } from "react-router-dom";
const ColorlibConnector = styled(StepConnector)(({ theme }) => ({
  [`&.${stepConnectorClasses.alternativeLabel}`]: {
    top: 22,
  },
  [`& .${stepConnectorClasses.line}`]: {
    height: 3,
    border: 0,
    backgroundImage: "linear-gradient(135deg, #f94a5f, #ec3b83)",
    borderRadius: 1,
  },
}));

const ColorlibStepIcon = () => (
  <div
    style={{
      background: "linear-gradient(135deg, #f94a5f, #ec3b83)",
      width: 40,
      height: 40,
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      borderRadius: "50%",
      boxShadow: "0 4px 10px rgba(0,0,0,0.2)",
      transition: "background 0.3s ease-in-out",
    }}
  >
    <SchoolIcon />
  </div>
);

const About = () => {
  const steps = [
    "Secondary School",
    "Primary School",
    "High School",
    "University",
  ];
  const SkillBadge = ({ skill }) => (
    <span
      style={{
        display: "inline-flex",
        alignItems: "center",
        gap: "6px",
        padding: "4px 12px",
        borderRadius: "6px",
        fontSize: "0.78rem",
        fontWeight: 500,
        background: "rgba(255,255,255,0.06)",
        border: "1px solid #00aceb",
        margin: "4px",
        backdropFilter: "blur(4px)",
        transition: "all 0.2s ease",
        cursor: "default",
      }}
      onMouseEnter={(e) => {
        e.currentTarget.style.background = "#00aceb";
      }}
      onMouseLeave={(e) => {
        e.currentTarget.style.background = "rgba(255,255,255,0.06)";
      }}
    >
      <img
        src={skill.icon}
        alt={skill.name}
        style={{ width: 16, height: 16, objectFit: "contain" }}
        onError={(e) => (e.currentTarget.style.display = "none")}
      />
      {skill.name}
    </span>
  );
  const RoleCard = ({ role, isLast }) => {
    const [expanded, setExpanded] = useState(true);
    return (
      <div
        style={{ display: "flex", gap: "0", marginBottom: isLast ? 0 : "0" }}
      >
        {/* Timeline dot + line */}
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            marginRight: "24px",
            position: "relative",
          }}
        >
          {/* Dot */}
          <div
            style={{
              width: 14,
              height: 14,
              borderRadius: "50%",
              background: "#00aceb",
              boxShadow: "0 0 12px rgba(16,185,129,0.5)",
              flexShrink: 0,
              marginTop: "6px",
              zIndex: 1,
            }}
          />
          {/* Line */}
          {!isLast && (
            <div
              style={{
                width: 2,
                flexGrow: 1,
                background: "#00aceb",
                marginTop: "6px",
                minHeight: "40px",
              }}
            />
          )}
        </div>

        {/* Content */}
        <div style={{ flex: 1, paddingBottom: isLast ? 0 : "32px" }}>
          {/* Period label */}
          <div
            style={{
              fontSize: "0.75rem",
              marginBottom: "8px",
              fontFamily: "'JetBrains Mono', monospace",
              letterSpacing: "0.05em",
            }}
          >
            {role.period}
          </div>

          {/* Role title */}
          <h3
            style={{
              fontSize: "1.1rem",
              fontWeight: 700,
              margin: "0 0 8px 0",
              fontFamily: "'Outfit', sans-serif",
            }}
          >
            {role.title}
          </h3>

          {/* Basic Skills toggle */}
          <button
            onClick={() => setExpanded(!expanded)}
            style={{
              background: "none",
              border: "none",
              padding: 0,
              cursor: "pointer",
              fontSize: "0.8rem",
              fontWeight: 600,
              marginBottom: expanded ? "12px" : 0,
              display: "flex",
              alignItems: "center",
              gap: "4px",
            }}
          >
            <span style={{ fontSize: "1rem" }}>{expanded ? "−" : "+"}</span>{" "}
            Basic Skills
          </button>

          {/* Skills badges */}
          {expanded && (
            <div
              style={{ display: "flex", flexWrap: "wrap", marginLeft: "-4px" }}
            >
              {role.skills.map((skill, i) => (
                <SkillBadge key={i} skill={skill} />
              ))}
            </div>
          )}
        </div>
      </div>
    );
  };
  return (
    <div className="container">
      <div className="row align-items-center justify-content-center px-3 py-5">
        {/* Text Section */}
        <div
          className="col-12 col-lg-6 mt-4 font-Style text-center text-lg-start"
          data-aos="fade-up"
        >
          <h4 className="text-info fs-6 fw-bold text-uppercase">WHO AM I?</h4>
          <p>
            I am a junior student at{" "}
            <a
              target="blank"
              href="https://www.ntti.edu.kh/"
              className="fw-bold text-decoration-none text-info"
            >
              National Technical Training Institute
            </a>
            , Majoring in{" "}
            <a
              target="blank"
              href="https://en.wikipedia.org/wiki/Information_technology"
              className="fw-bold text-decoration-none text-info"
            >
              Information Technology
            </a>
            . Alongside my study, I also intern as a <br />
            <span className="fw-bold">Front-End Developer</span> at{" "}
            <a
              target="blank"
              href="https://kh.linkedin.com/company/kiloit-org"
              className="fw-bold text-decoration-none text-info"
            >
              KiloIT
            </a>
            , where I have gained a solid foundation in HTML, CSS, JavaScript,
            React JS, Bootstrap5, and more.
          </p>
          <p>
            I started my career as a Front-end Developer in 2023, and I have a
            passion for creating beautiful and functional user interfaces. I
            love to learn new technologies and improve my skills every day. I am
            also a big fan of open-source projects and I enjoy contributing to
            the community.
          </p>
        </div>

        {/* Image Section */}
        <div className="col-12 col-lg-6 text-center" data-aos="fade-up">
          <img
            className="img-fluid w-75 mt-4 mt-lg-5 mb-4"
            src={picme4}
            alt="About me"
          />
        </div>
      </div>
      <section>
        <div>
          {/* Section heading */}
          <h3
            style={{
              fontSize: "clamp(1.5rem, 5vw,2rem)",
              fontWeight: 900,
              marginBottom: "52px",
              letterSpacing: "-0.02em",
              lineHeight: 1.1,
            }}
          >
            Exper<span style={{ color: "#00aceb" }}>ience</span>
          </h3>
          {experiences.map((company, ci) => (
            <div key={ci} style={{ marginBottom: "52px" }}>
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  gap: "12px",
                  marginBottom: "28px",
                }}
              >
                <div
                  style={{
                    width: 32,
                    height: 32,
                    borderRadius: "6px",
                    background: "rgba(255, 255, 255, 0.07)",
                    border: "1px solid #00aceb",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    overflow: "hidden",
                    flexShrink: 0,
                  }}
                >
                  <img
                    src={company.logo}
                    alt={company.company}
                    style={{ width: 22, height: 22, objectFit: "contain" }}
                    onError={(e) => (e.currentTarget.style.display = "none")}
                  />
                </div>
                <Link
                  to={company.url}
                  target="_blank"
                  className="text-decoration-none text-info"
                >
                  <h2
                    style={{
                      fontSize: "1rem",
                      fontWeight: 700,
                      margin: 0,
                      letterSpacing: "0.08em",
                      textTransform: "uppercase",
                    }}
                  >
                    {company.company}
                  </h2>
                </Link>
              </div>
              {/* Timeline with vertical line from company */}
              <div>
                {company.roles.map((role, ri) => (
                  <RoleCard
                    key={ri}
                    role={role}
                    isLast={ri === company.roles.length - 1}
                  />
                ))}
              </div>
            </div>
          ))}
        </div>
      </section>
      <div className="text-center my-5 position-relative">
        <div className="d-inline-block px-4 py-2 rounded-lg shadow animated-gradient-bg">
          <i className="bi bi-mortarboard-fill me-2"></i>
          <span className="text-uppercase fw-bold">
            Educational Background
          </span>
        </div>
      </div>
      {/* Custom Stepper */}
      <div className="mb-5">
        <Stepper
          alternativeLabel
          activeStep={-1}
          connector={<ColorlibConnector />}
        >
          {steps.map((label, index) => (
            <Step key={index}>
              <StepLabel StepIconComponent={ColorlibStepIcon}>
                <span className="dark-color">{label}</span>
              </StepLabel>
            </Step>
          ))}
        </Stepper>
      </div>
      {/* Skills */}
      <div className="text-center my-5">
        <h2 className="text-uppercase fw-bold">My Main Skills</h2>
      </div>

      <div className="row g-4 mb-4">
        <Swiper
          effect="coverflow"
          grabCursor={true}
          centeredSlides={true}
          slidesPerView="auto"
          loop={true}
          coverflowEffect={{
            rotate: 30,
            stretch: 0,
            depth: 150,
            modifier: 2.5,
            slideShadows: true,
          }}
          autoplay={{ delay: 2500, disableOnInteraction: false }}
          pagination={{ clickable: true }}
          modules={[EffectCoverflow, Autoplay, Pagination]}
          className="mySwiper"
        >
          {skill.map((items, index) => (
            <SwiperSlide key={index} style={{ width: "300px" }}>
              <div className="border border-secondary rounded-4 h-100 hover-shadow transition bg-white">
                <div className="p-4 d-flex flex-column align-items-center gap-3 text-center">
                  <img
                    src={items.icon}
                    alt={items.title}
                    className="img-fluid"
                    style={{
                      width: "60px",
                      height: "60px",
                      objectFit: "contain",
                    }}
                  />
                  <div>
                    <h4 className="fw-bold mb-2">{items.title}</h4>
                    <p
                      className="text-secondary mb-0 text-truncate-multiline"
                      style={{
                        display: "-webkit-box",
                        WebkitLineClamp: 2,
                        WebkitBoxOrient: "vertical",
                        overflow: "hidden",
                      }}
                    >
                      {items.des}
                    </p>
                  </div>
                </div>
              </div>
            </SwiperSlide>
          ))}
        </Swiper>
      </div>
    </div>
  );
};

export default About;
